const runtimeValue = (value) => String(value == null ? '' : value).trim().toLowerCase();
const envValue = (key) => {
  try {
    return typeof process !== 'undefined' ? process?.env?.[key] : undefined;
  } catch (_) {
    return undefined;
  }
};

export function isZodiacCrushQaUnlockEnabled(options = {}) {
  const nodeEnv = options.nodeEnv ?? envValue('NODE_ENV');
  if (nodeEnv === 'production') return false;

  const envFlag = options.envFlag ?? envValue('REACT_APP_ZC_UNLOCK_ALL');
  const search = options.search ?? (
    typeof window !== 'undefined' ? window.location?.search : ''
  );
  const storage = options.storage ?? (
    typeof window !== 'undefined' ? window.localStorage : null
  );

  if (runtimeValue(envFlag) === '1') return true;

  try {
    const queryValue = runtimeValue(new URLSearchParams(search || '').get('unlockAll'));
    if (queryValue === '1' || queryValue === 'true') return true;
  } catch (_) {}

  try {
    return runtimeValue(storage?.getItem('zc_unlock_all')) === '1';
  } catch (_) {
    return false;
  }
}

export function getZodiacCrushEffectiveMaxUnlocked(maxUnlockedLevel, options) {
  if (isZodiacCrushQaUnlockEnabled(options)) return 9999;
  const value = Math.floor(Number(maxUnlockedLevel));
  return Number.isFinite(value) && value > 0 ? value : 1;
}
